export const formatPoints = (points: number): string => {
  if (!points) return "0";
  if (isNaN(points)) return "";

  return `${Math.round(points)}`;
};
